import "../styles/Spinner.scss";

const Spinner = () => {
  return (
    <div className="spinner">
      <div className="spinner__loading"></div>
    </div>
  )
}

export default Spinner 